<template>
  <div id="menu">

    <!-- Profile Name -->

    <h1> {{ name }} </h1>

    <!-- Social Networks Tab -->

    <div class="social">
      <md-button v-for="item in social" v-bind:key="item.name" :href="item.url" class="md-icon-button" target="_blank">
        <md-icon :class="item.icon"></md-icon>
        <md-tooltip>{{ item.name }}</md-tooltip>
      </md-button>
    </div>

    <p><md-button :href='require("@/assets/cv/cv.pdf")' target="_blank" class="md-raised md-primary">{{ $t("my-cv") }}</md-button>
    <md-button :href='require("@/assets/cv/cv_extended.pdf")' target="_blank" class="md-raised md-primary">{{ $t("my-extended-cv") }}</md-button></p>

    <!-- Desktop Menu -->

    <md-list class="md-small-hide">
      <md-list-item v-for="item in items" v-bind:key="item.name" :to="item.path" exact>
        <md-icon>{{ item.icon }}</md-icon>
        <span class="md-list-item-text">{{ $t(item.name) }}</span>
      </md-list-item>
    </md-list>

    <!-- Locales Switcher -->

    <div class="locales">
      <div :class="locale.code" v-for="locale in locales" :key="locale.code" @click="switchLocale(locale.code)">
        <md-button class="md-icon-button" :alt="locale.code" :title="locale.name">
          <img :src="locale.img" :alt="locale.code">
          <md-tooltip>{{ locale.name }}</md-tooltip>
        </md-button>
      </div>
    </div>

    <!-- Mobile Menu -->

    <div id="mobile-menu" class="list">
      <md-list>
        <md-list-item md-expand>
          <md-icon>menu</md-icon>
          <span class="md-list-item-text">Menu</span>

          <md-list slot="md-expand">
            <md-list-item v-for="item in items" v-bind:key="item.name" :to="item.path" exact>
                <md-icon>{{ item.icon }}</md-icon>
                <span class="md-list-item-text">{{ item.name }}</span>
            </md-list-item>
          </md-list>

        </md-list-item>
      </md-list>
    </div>

  </div>
</template>

<script>

import en from "@/assets/en.png"
import ptBR from "@/assets/pt-BR.png"
import i18n from '@/i18n'

export default {
  name: 'Menu',
  components: {},
  methods: { // <---------------------------
    switchLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        this.$cookie.set('locale', locale);
        document.title = "Fabrício Ceschin - " + i18n.t(this.$route.meta.title)
      }
    }
  },
  data() {
    return {
      locales: [
        { code: "en", name: "English", img: en },
        { code: "pt-BR", name: "Português (BR)", img: ptBR }
      ]
    }
  },
  props: {
    name: String,
    items: Array,
    social: Array
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* bigger than small */
@media (min-width: 961px) {
  #mobile-menu {
    display: none;
  }

}

#mobile-menu .md-list.md-theme-default {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}

#menu .md-list {
  padding-bottom:0;
}

.md-list-item-expand {
  border-top: 0;
}

.md-list-item-expand.md-active {
  background-color:#656565;
}

.md-list-item::marker {
  display:none;
}

#menu {
  text-align:center;
}

.locales {
  display: inline-flex;
  padding-bottom: 10px;
  padding-top: 10px;
}

.locales .en {
  margin-right:5px;
}

.locales .md-icon-button {
  margin: 0 !important;
}

.locales div {
  cursor: pointer;
}

</style>
